import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const taskTypeRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.taskTypes,
    name: routeNames.taskTypes,
    component: () => import('@/pages/task-types/TaskTypesView.vue'),
    meta: {
      labelKey: 'taskTypes',
      iconText: 'assignment',
      icon: 'material-symbols-outlined',
      permission: 'task-types.read.all',
      featureFlag: 'tasks',
    },
  },
  {
    path: routePaths.taskTypeDetails,
    name: 'task-type-details',
    redirect: (to) => ({ name: routeNames.taskTypeEdit, params: { id: to.params.id } }),
    meta: {
      permission: 'task-types.write.all',
      rootRouteName: routeNames.taskTypes,
      featureFlag: 'tasks',
    },
  },
  {
    path: routePaths.taskTypeCreation,
    name: routeNames.taskTypeCreation,
    component: () => import('@/pages/task-types/AddEditTaskTypeView.vue'),
    meta: {
      labelKey: 'new_m',
      permission: 'task-types.write.all',
      featureFlag: 'tasks',
      rootRouteName: routeNames.taskTypes,
    },
  },
  {
    path: routePaths.taskTypeEdit,
    name: routeNames.taskTypeEdit,
    component: () => import('@/pages/task-types/AddEditTaskTypeView.vue'),
    meta: {
      labelKey: 'edit',
      permission: 'task-types.write.all',
      featureFlag: 'tasks',
      rootRouteName: routeNames.taskTypes,
    },
  },
]
